var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPencilRuler = function SvgPencilRuler(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 37 37"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m19.667 10.999-6.45-6.45a3.615 3.615 0 0 0-5.1 0l-3.9 3.9a3.615 3.615 0 0 0 0 5.1l6.45 6.45M12.167 9.5l3-3M27.167 24.5l3-3M25.667 17l6.45 6.45a3.603 3.603 0 0 1 0 5.1l-3.9 3.9a3.603 3.603 0 0 1-5.1 0L16.667 26M31.927 10.719a4.228 4.228 0 1 0-5.979-5.98L5.93 24.761a3 3 0 0 0-.75 1.245l-1.981 6.528a.75.75 0 0 0 .934.933l6.53-1.98a3 3 0 0 0 1.245-.746zM22.667 8l6 6"
  })));
};
export default SvgPencilRuler;